import type { UserCommunicationAttachment } from '@this+that/models';

const ATTACHMENT_KEY_SEPARATOR = '\u0000';

const attachmentKey = (attachment: UserCommunicationAttachment): string =>
  `${attachment.fileName}${ATTACHMENT_KEY_SEPARATOR}${attachment.fileType}`;

export const mergeRowAttachments = (
  base: UserCommunicationAttachment[] = [],
  winning: UserCommunicationAttachment[] = [],
): UserCommunicationAttachment[] => {
  const winningKeys = new Set(winning.map(attachmentKey));
  return [
    ...base.filter((attachment) => !winningKeys.has(attachmentKey(attachment))),
    ...winning,
  ];
};
